import { useState } from "react";
import { AuthMyReservations } from "../components/api";

export default function useReservations() {
  const [data, setData] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const checkLogin = () => {
    setLoading(true);
    AuthMyReservations()
      .then((response) => {
        if (response.data.error) {
          setError(response.data.error);
          setData([]);
        } else {
          setData(response.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  return {
    loading,
    error,
    data,
    setData,
    setLoading,
    checkLogin,
  };
}
